import { observable } from 'mobx';

import store from '../store';
import { CURRENCIES } from '../constants/currencies';
import { LOCATIONS, KCI_WEB_LOCATION_ID } from '../constants/locations';

class ShopStore {

    cartItems = observable.map({}); // Depracated
    cart = observable.map({ items: [], coupon: '' });
    recurrenceFrequency = observable.box(null);
    processingCart = observable.box(false);
    processingOrder = observable.box(false);
    billingInfo = observable.map({});
    billingInfoErrors = observable.map({});
    cashsale = observable.box(null);
    purchaseError = observable.box(null);
    preloadedSku = null;
    enableCoupons = false;
    locationId = null;
    location = observable.box(LOCATIONS[KCI_WEB_LOCATION_ID]);
    currency = observable.box(CURRENCIES.usd);
    docebo = observable.map({
        enroll: false,
        processing: false,
        userSearchCompleted: false,
        existingUserId: null,
        password: '',
        confirmPassword: '',
        formError: '',
        searchError: '',
        completed: false,
        enrollError: '',
    })
    recaptchaResponse = null;
    donationDedication = observable.box('');

    getTotal() {
        let total = 0.00;
        for (const item of this.cartItems.values()) {
            total = parseFloat(total) + parseFloat(item.price);
            total = parseFloat(total).toFixed(2);               
        }   
        return parseFloat(total).toFixed(2); 
    }

    setCart(skus, coupon, amount, ticketId) {
        let items = [];
        skus.map(sku => {
            items.push({ sku: sku, amount: amount, ticketId: ticketId });
            return null;
        });
        this.cart.set('items', items);
        if (coupon) {
            this.cart.set('coupon', coupon);
        }           
        this.fetchHypoCashsale();
    }

    fetchHypoCashsale() {
        this.processingCart.set(true);
        this.cart.set('hypoCashsale', null);
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'constructCart',
            sessionToken: store.sessionToken,
            data: {
                items: this.cart.get('items'),
                coupon: this.cart.get('coupon'),
                currency: this.currency.get().netsuiteId,
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
        })
        .then(res => res.json())        
        .catch(error => {
            console.log('Error constructing cart. (1)');
        })
        .then(json => {
            console.log('XXXX', json);
            if (json.status !== 'ok') {
                console.log('Error constructing cart. (2)');
            }
            else {              
                this.cart.set('hypoCashsale', json.data);               
            }            
            this.processingCart.set(false);
        }) 
        .catch(error => {
            console.log('Error constructing cart. (3)');
        });          
    }

    addToCartBySku(sku) {       
        this.processingCart.set(true);
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'getProduct',
            sessionToken: store.sessionToken,
            data: {
                sku: sku,
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            /*headers:{                
                'User-Agent': 'Mozilla/5.0',                
            }*/
        })
        .then(res => res.json())        
        .catch(error => {
            console.log('Error adding SKU to cart.');
        })
        .then(json => {
            //console.log(json);
            if (json.status !== 'ok') {
                console.log('Error adding SKU to cart.');
            }
            else {              
                const netsuiteItem = json.data.item;
                const cartItem = {
                    id: netsuiteItem.id,
                    sku: netsuiteItem.values.itemid,
                    name: netsuiteItem.values.displayname,
                    price: netsuiteItem.values.baseprice,
                }
                this.cartItems.set(cartItem.id, cartItem);                
            }            
            this.processingCart.set(false);
        }) 
        .catch(error => {
            console.log('Error adding SKU to cart.');
        });                     
    }    

    purchaseCart() {            
        this.processingOrder.set(true);
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'purchaseProducts',
            sessionToken: store.sessionToken,
            data: {},
        };
        for (const entry of this.billingInfo.entries()) {    
            body.data[entry[0]] = entry[1];
        }    
        if (this.billingInfo.get('ccexpiremonth') && this.billingInfo.get('ccexpireyear')) {
            body.data.ccexpiredate = this.billingInfo.get('ccexpiremonth') + '/' + 
                    this.billingInfo.get('ccexpireyear');
        }
        if (this.locationId) {
            body.data.locationid = this.locationId;
        }
        body.data.currency = this.currency.get().netsuiteId;
        body.data.items = []; 
        if (this.cartItems.size > 0) {
            for (const item of this.cartItems.values()) {
                let dedicationText = '';
                if (this.donationDedication.get()) {
                    dedicationText = ' [Dedication: ' + this.donationDedication.get() + ']';
                }
                body.data.items.push({
                    sku: item.sku,
                    amount: item.price,
                    description: item.name + dedicationText,                    
                });           
            }  
        } else {
            body.data.items = this.cart.get('items');            
            body.data.coupon = this.cart.get('coupon');
        } 
        if (this.recurrenceFrequency.get()) {
            body.data.custbody_recurrence_frequency = this.recurrenceFrequency.get();
        }
        body.data.recaptcharesponse = this.recaptchaResponse;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            /*headers:{                
                'User-Agent': 'Mozilla/5.0',                
            }*/
        })
        .then(res => res.json())
        .catch(error => {
            this.purchaseError.set('An unexpected error has occurred.');   
            //console.log('Caught error (1):', error);         
        })
        .then(json => {
            console.log('Response body (json): ', json);
            if (!json) {
                console.log('Error: received null response body.');
                this.purchaseError.set('An unexpected error has occurred.');
            } else if (json.status !== 'ok') {
                console.log('Error: received failed status.');
                console.log(json);
                this.purchaseError.set(json.errors[0]);                 
            } else {       
                console.log('Success!');         
                this.cashsale.set(json.data.cashsale);
                this.cartItems.replace({});
            }            
            this.processingOrder.set(false);
        })  
        .catch(error => {
            this.purchaseError.set('An unexpected error has occurred.');   
            console.log('Caught error (2):', error);          
        });                    
        // TODO Need to clear cart after purchase 
    }   
    
    searchDoceboUser() {
        this.docebo.set('processing', true);        
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'searchDoceboUser',
            data: {
                email: this.billingInfo.get('email'),                
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
        })
        .then(res => res.json())        
        .catch(error => {
            console.log('Error in user search (1).');
            this.docebo.set('enrollError', 'An unexpected error has occurred.');
        })
        .then(json => {
            console.log(json);
            if (json.status !== 'ok') {
                console.log('Error in user search (2).');
                this.docebo.set('enrollError', 'An unexpected error has occurred.');
            }
            else {  
                this.docebo.set('userSearchCompleted', true);            
                if (json.data.found) {
                    this.docebo.set('existingUserId', json.data.userId);  
                    this.enrollInDocebo();             
                }             
            }            
            this.docebo.set('processing', false);
        }) 
        .catch(error => {
            console.log('Error in user search (3).');
            this.docebo.set('searchError', 'An unexpected error has occurred.');
        });          
    }    

    enrollInDocebo() {
        this.docebo.set('processing', true);        
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'enrollInDocebo',
            data: {
                cashsaleid: this.cashsale.get().id,
                password: this.docebo.get('password'),
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
        })
        .then(res => res.json())        
        .catch(error => {
            console.log('Error in LMS enrollment (1).');
            this.docebo.set('enrollError', 'An unexpected error has occurred.');
        })
        .then(json => {
            console.log(json);
            if (json.status !== 'ok') {
                console.log('Error in LMS enrollment (2).');
                this.docebo.set('enrollError', 'An unexpected error has occurred.');
            }
            else {              
                this.docebo.set('completed', true);               
            }            
            this.docebo.set('processing', false);
        }) 
        .catch(error => {
            console.log('Error in LMS enrollment (3).');
            this.docebo.set('enrollError', 'An unexpected error has occurred.');
        });          
    }       

}

let shopStore = new ShopStore();
export default shopStore;


// WEBPACK FOOTER //
// ./src/stores/shopStore.js